export default __webpack_public_path__ + "1f380de3e94d5534349798b4efedde21.svg";